/*
 * @Author: your name
 * @Date: 2022-01-04 17:09:31
 * @LastEditTime: 2022-07-13 16:27:26
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jeecg-boot\ant-design-vue-jeecg\src\config\index.js
 */
/** init domain config */
import Vue from 'vue'
// 设置全局API_BASE_URL
Vue.prototype.API_BASE_URL = window.ENV_CONFIG ? `${window.ENV_CONFIG.baseUrl}/jeecg-boot` : 'https://api.dev.designorder.cn/designBackend/jeecg-boot'
// Vue.prototype.API_BASE_URL = window.ENV_CONFIG.domianURL
window._CONFIG['domianURL'] = Vue.prototype.API_BASE_URL
// window._CONFIG['workbench'] = 'https://api.dev.designorder.cn/designBackend/doMistServer'
// window._CONFIG['library'] = 'http://192.168.0.60:9190'
// 单点登录地址
// window._CONFIG['casPrefixUrl'] = window.ENV_CONFIG ? window.ENV_CONFIG.casPrefixUrl : ''
// window._CONFIG['onlinePreviewDomainURL'] = window.ENV_CONFIG ? window.ENV_CONFIG.onlinePreviewDomainURL : ''
// window._CONFIG['staticDomainURL'] = Vue.prototype.API_BASE_URL + '/sys/common/static'
// window._CONFIG['pdfDomainURL'] = Vue.prototype.API_BASE_URL + '/sys/common/pdf/pdfPreviewIframe'
// window._CONFIG['doBaseUrl'] = 'http://localhost:9190'
window._CONFIG['doBaseUrl'] = window.ENV_CONFIG ? window.ENV_CONFIG.baseUrl : 'https://api.dev.designorder.cn/designBackend'
window._CONFIG['yunDesignUrl'] = window.ENV_CONFIG ? window.ENV_CONFIG.yunDesignUrl : 'https://design.dev.designorder.cn/design'
window._CONFIG['ossPathUrl'] = window.ENV_CONFIG ? window.ENV_CONFIG.ossPrefix : 'https://designorder.oss-cn-shanghai.aliyuncs.com'
window._CONFIG['twodUrl'] = window.ENV_CONFIG ? window.ENV_CONFIG.twodUrl : 'https://drawing.dev.designorder.cn'
window._CONFIG['resourceUrl'] = window.ENV_CONFIG ? window.ENV_CONFIG.resourceUrl : 'https://resource.dev.designorder.cn'
